var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useMemo, useState } from 'react';
import { DefaultCard } from '../../../../components/DefaultCard';
import { DefaultContent } from '../../../../components/DefaultContent';
import { ShowContent } from '../../../../components/ShowContent';
import { ChecklistAnexoList } from './ChecklistAnexoList';
import { RequerimentosApi } from '../../../../apis/requerimento-api';
import { HandleError } from '../../../utils/HandleError';
import { Grid, Typography } from '@mui/material';
export var TerceiraAbaRequerimento = function (_a) {
    var requerimento = _a.requerimento, onChange = _a.onChange, requerimentoFieldError = _a.requerimentoFieldError, requerimentoFieldErrorChange = _a.requerimentoFieldErrorChange, onValidate = _a.onValidate;
    //region Constants
    var _b = useState(null), checklist = _b[0], setChecklist = _b[1];
    var _c = useState(false), loading = _c[0], setLoading = _c[1];
    var _d = useState(undefined), error = _d[0], setError = _d[1];
    //endregion
    //region Hooks
    useEffect(function () {
        handleLoadChecklist();
    }, []);
    useEffect(function () {
    }, [checklist]);
    //endregion
    //region Handles
    var handleLoadChecklist = function () {
        if (requerimento === null || requerimento === void 0 ? void 0 : requerimento.id) {
            setLoading(true);
            RequerimentosApi.checklist(requerimento === null || requerimento === void 0 ? void 0 : requerimento.id)
                .then(function (response) {
                onChange === null || onChange === void 0 ? void 0 : onChange(__assign(__assign({}, requerimento), { checklist: __assign(__assign({}, response), { sessoes: [] }) }));
                setChecklist(response);
            })
                .catch(function (err) { return setError(err); })
                .finally(function () { return setLoading(false); });
        }
    };
    var show = useMemo(function () {
        return checklist !== undefined && checklist !== null && !!(checklist === null || checklist === void 0 ? void 0 : checklist.id);
    }, [checklist]);
    //endregion
    return (_jsx(DefaultCard, __assign({ title: '', subTitle: '', style: { background: 'transparent', padding: '0', border: 'none', boxShadow: 'none', width: '100%' } }, { children: _jsxs(DefaultContent, __assign({ loading: loading }, { children: [_jsx(ShowContent, __assign({ show: show }, { children: _jsx(ChecklistAnexoList, { requerimentoFieldErrorChange: function (erros) { return requerimentoFieldErrorChange === null || requerimentoFieldErrorChange === void 0 ? void 0 : requerimentoFieldErrorChange(__assign({}, erros)); }, onChange: function (_requerimento) { return onChange === null || onChange === void 0 ? void 0 : onChange(__assign({}, _requerimento)); }, onValidate: function (calback) { return onValidate === null || onValidate === void 0 ? void 0 : onValidate(calback); }, requerimentoFieldError: requerimentoFieldError, requerimento: requerimento, checklist: checklist }) })), _jsx(ShowContent, __assign({ show: !show }, { children: _jsx(DefaultCard, __assign({ title: '', subTitle: '', style: { width: '100%' } }, { children: _jsx(Grid, __assign({ item: true, xs: 12 }, { children: _jsx(Typography, __assign({ className: 'card-header-title', textAlign: 'center' }, { children: "Nenhum Checklist de anexos configurado para o tipo de servi\u00E7o selecionado." })) })) })) })), _jsx(HandleError, { error: error, handleClose: function () { return setError(undefined); } })] })) })));
};
